export const translations = {
	'Required field': {
		en: 'Required field',
        no: 'PÃ¥krevd felt',
	},
	'Invalid child': {
		en: 'Invalid node',
        no: 'ugyldig node',
	},
	'This change needed confirmation': {
		en: 'This change needed confirmation',
        no: 'Denne endringen krever bekreftelse',
	},
	'This change will clear the following properties: ': {
		en: 'This change will clear the following properties: ',
        no: 'Denne endringen vil fjene fÃ¸lgende innstillinger: ',
	},
	'Create new authentication': {
		en: 'Create new authentication',
		no: 'Opprett ny autentisering',
	},
	'Show advanced tooltip': {
		en: 'Show advanced options. Advanced settings remain active even when hidden.',
		no: 'Vis avanserte alternativer. Avanserte innstillinger forblir aktive selv nÃ¥r de er skjult.',
	},
	'Show advanced': {
		en: 'Show advanced',
		no: 'Vis avansert',
	},
	'Hide advanced': {
		en: 'Hide advanced',
		no: 'Skjul avansert',
	},
	'Delete selected item?': {
		en: 'Delete selected?',
        no: 'Slett valgt?',
	},
	'Delete selected items?': {
		en: 'Delete selected?',
        no: 'Slett valgt?',
	},
	'Reset to Defaults': {
		en: 'Reset to default',
        no: 'Tilbakestill til standard',
	},
};
